import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t-[3px] border-black z-50 shadow-lg">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="font-bold text-black mb-1">🍪 Slapukų naudojimas</h3>
            <p className="text-sm text-gray-600">
              Mes naudojame slapukus, kad pagerintume jūsų naršymo patirtį, analizuotume svetainės lankomumą ir pateiktume pritaikytą turinį. 
              Paspausdami „Sutinku", jūs sutinkate su visų slapukų naudojimu. Norėdami sužinoti daugiau, skaitykite mūsų{' '}
              <a href="/privatumo-politika" className="underline hover:text-black">
                Privatumo politiką
              </a>.
            </p>
          </div>
          <div className="flex gap-3 flex-shrink-0">
            <button
              onClick={handleDecline}
              className="px-6 py-2 border-2 border-black text-black font-medium hover:bg-gray-100 transition-colors"
            >
              Atmesti
            </button>
            <button
              onClick={handleAccept}
              className="px-6 py-2 text-black font-medium transition-colors hover:opacity-90"
              style={{ backgroundColor: '#D0AB64' }}
            >
              Sutinku
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;

